export default __webpack_public_path__ + "static/media/s9.59b60237.jpg";